import { Fragment } from "react";
import { Transition } from "@headlessui/react";
import { CheckIcon, EyeIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { Button } from "common/src/styles";
import DefaultLogoImage from "../../assets/default_logo.png";
import { renderToPlainText } from "common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function CartNotification(props) {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      "aria-live": "assertive",
      className: "pointer-events-none fixed top-12 inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6 z-50",
      children: /*#__PURE__*/_jsx("div", {
        className: "flex w-full flex-col items-center space-y-4 sm:items-end",
        children: /*#__PURE__*/_jsx(Transition, {
          show: props.showCartNotification,
          as: Fragment,
          enter: "transform ease-out duration-300 transition",
          enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
          enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
          leave: "transition ease-in duration-100",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /*#__PURE__*/_jsx("div", {
            className: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5",
            children: /*#__PURE__*/_jsx("div", {
              className: "p-4",
              children: /*#__PURE__*/_jsxs("div", {
                className: "flex flex-col",
                children: [/*#__PURE__*/_jsxs("div", {
                  className: "flex items-center justify-between",
                  children: [/*#__PURE__*/_jsxs("p", {
                    className: "flex mb-4 pb-2 gap-2 text-sm",
                    children: [/*#__PURE__*/_jsx(CheckIcon, {
                      className: "w-4"
                    }), "Project added to your cart"]
                  }), /*#__PURE__*/_jsxs("button", {
                    className: "text-gray-400 hover:text-gray-500 pb-6",
                    onClick: () => props.setShowCartNotification(false),
                    children: [/*#__PURE__*/_jsx("span", {
                      className: "sr-only",
                      children: "Close"
                    }), /*#__PURE__*/_jsx(XMarkIcon, {
                      className: "h-5 w-5",
                      "aria-hidden": "true"
                    })]
                  })]
                }), /*#__PURE__*/_jsx(ProjectView, {
                  project: props.currentProjectAddedToCart
                }), /*#__PURE__*/_jsx(Button, {
                  type: "button",
                  $variant: "solid",
                  className: "px-3 bg-violet-400 text-white border-0 text-xs mb-2",
                  onClick: () => {
                    const url = "#/cart";
                    window.open(url, "_blank");
                  },
                  children: "View my cart"
                })]
              })
            })
          })
        })
      })
    })
  });
}
export function ProjectView(props) {
  return /*#__PURE__*/_jsxs("div", {
    className: "flex mb-4",
    "data-testid": "project-quick-view",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "relative overflow-hidden bg-no-repeat bg-cover  min-w-[64px] w-16 max-h-[64px] mt-auto mb-auto",
      children: [/*#__PURE__*/_jsx("img", {
        className: "inline-block",
        src: props.project.projectMetadata.logoImg ? `${process.env.REACT_APP_IPFS_BASE_URL}/ipfs/${props.project.projectMetadata.logoImg}` : DefaultLogoImage,
        alt: "Project Logo"
      }), /*#__PURE__*/_jsx("div", {
        className: "min-w-[64px] w-16 max-h-[64px] absolute top-0 right-0 bottom-0 left-0 overflow-hidden bg-fixed opacity-0 hover:opacity-70 transition duration-300 ease-in-out bg-gray-500 justify-center flex items-center",
        children: /*#__PURE__*/_jsx(EyeIcon, {
          className: "fill-gray-200 w-6 h-6 cursor-pointer",
          "data-testid": `${props.project.projectRegistryId}-project-link`
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "pl-4 mt-1",
      children: [/*#__PURE__*/_jsx("p", {
        className: "font-semibold mb-2 text-sm text-ellipsis line-clamp-1",
        children: props.project.projectMetadata.title
      }), /*#__PURE__*/_jsx("p", {
        className: "text-xs text-ellipsis line-clamp-3",
        children: renderToPlainText(props.project.projectMetadata.description).substring(0, 20)
      })]
    })]
  });
}